import {
  apiRequest,
  dokumenPensiunDetail,
  dokumenPensiunListPension,
  dokumenPensiunListStop,
} from "../../../../../services/adapters/master/dokumenPensiunService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunDetail,
      {
        params: query,
      },
      true
    );
  };
  fetchTypePension = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListPension,
      {
        params: query,
      },
      true
    );
  };

  fetchTypeStop = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListStop,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
